// extracted by mini-css-extract-plugin
export var closeButton = "_n1-1";
export var closeX = "_n1-3";
export var container = "_n1-0";
export var image = "_n1-2";